module.exports = [
  {
    maxSize: 4,
    isPaid: false,
    name: 'small',
    cost: {
      gbp: {
        price: 0,
        priceText: 'Free',
        upgrade: 0,
        upgradePriceText: 'Free'
      },
      eur: {
        price: 0,
        priceText: 'Free',
        upgrade: 0,
        upgradePriceText: 'Free'
      },
      usd: {
        price: 0,
        priceText: 'Free',
        upgrade: 0,
        upgradePriceText: 'Free'
      }
    },
    title: 'Taster Session',
    sizeText: 'Up to 4 players',
    description: 'Small gathering or just want to check it out?'
  },
  {
    maxSize: 10,
    isPaid: true,
    name: 'medium',
    cost: {
      gbp: {
        price: 5,
        priceText: '£5',
        upgrade: 5,
        upgradePriceText: '£5'
      },
      eur: {
        price: 6,
        priceText: '€6',
        upgrade: 6,
        upgradePriceText: '€6'
      },
      usd: {
        price: 7,
        priceText: '$7',
        upgrade: 7,
        upgradePriceText: '$7'
      }
    },
    title: 'Get Together',
    sizeText: '5 - 10 players',
    description: 'Get your mates together and get down the races'
  },
  {
    maxSize: 20,
    isPaid: true,
    name: 'large',
    cost:{
      gbp: {
        price: 10,
        priceText: '£10',
        upgrade: 5,
        upgradePriceText: '£5'
      },
      eur: {
        price: 12,
        priceText: '€12',
        upgrade: 6,
        upgradePriceText: '€6'
      },
      usd: {
        price: 14,
        priceText: '$14',
        upgrade: 7,
        upgradePriceText: '$7'
      }
    },
    title: 'The Party',
    sizeText: '11 - 20 players',
    description: 'Perfect for birthday parties and team meet ups.'
  },
  {
    maxSize: 50,
    isPaid: true,
    name: 'xlarge',
    cost:{
      gbp: {
        price: 20,
        priceText: '£20',
        upgrade: 10,
        upgradePriceText: '£10'
      },
      eur: {
        price: 24,
        priceText: '€24',
        upgrade: 12,
        upgradePriceText: '€12'
      },
      usd: {
        price: 28,
        priceText: '$28',
        upgrade: 14,
        upgradePriceText: '$14'
      }
    },
    title: 'The Big One',
    sizeText: '20 - 50 players',
    description: 'Got a larger group to entertain? We\'ve got you covered.'
  },
]
